<template>
  <div id="member-project" class="w-100">
    <div class="row mt-3 mx-0">
      <div class="col-12">
        <div class="form-group report-date-filter text-right">
          <span class="mr-3">คัดกรองจากวันที่</span>
          <el-date-picker
            v-model="defaultReportDate"
            format="dd-MM-yyyy HH:mm"
            start-placeholder="เริ่ม"
            end-placeholder="สิ้นสุด"
            range-separator="ถึง"
            type="datetimerange"
            name="dateFilter"
            :picker-options="datePickerOptions"
            @change="dateFilter"
          />
        </div>
        <div class="text-right">
          <label class="select-input"
            >เปรียบเทียบกับช่วงเวลา
            <input
              type="checkbox"
              name="compareDataWithDateRange"
              aria-required="true"
              aria-invalid="true"
              @click="compareDataWithDateRange = !compareDataWithDateRange"
            />
            <span class="checkmark checkbox error"></span>
          </label>
        </div>
        <div
          class="form-group report-date-filter text-right"
          v-if="compareDataWithDateRange"
        >
          <span class="mr-3">เลือกช่วงเวลาที่ต้องการเปรียบเทียบ</span>
          <el-date-picker
            v-model="defaultCompareDate"
            format="dd-MM-yyyy HH:mm"
            start-placeholder="เริ่ม"
            end-placeholder="สิ้นสุด"
            range-separator="ถึง"
            type="datetimerange"
            name="dateCompare"
            :picker-options="datePickerOptions"
            @change="dateCompare"
          />
        </div>
      </div>
    </div>
    <div class="row mx-0">
      <div class="col-12">
        <div class="text-right">
          <download-excel
            class="sc-btn sc-btn-outline"
            :fields="userStatField"
            :data="userStatData"
            type="xls"
            name="project-stat.xls"
            >ดาวน์โหลดข้อมูลลูกค้า</download-excel
          >
          <download-excel
            class="sc-btn sc-btn-outline"
            :fields="statField"
            :data="statData"
            type="xls"
            name="project-stat.xls"
            >ดาวน์โหลดข้อมูลโครงการ</download-excel
          >
        </div>
      </div>
    </div>
    <div class="row col mt-2 mx-0 px-0 content-list">
      <div class="col-6 d-flex" style="height: 100%">
        <div class="card col px-0 d-flex flex-column">
          <div class="card-header bg-warning text-white">
            <div class="media">
              <div class="media-body h2 text-white">
                {{ $t("feature.contact.project.low_rise") }}
              </div>
              <div class="ml-3">
                <search-input
                  @search="lowChange"
                  :placeholder="
                    $t('feature.member.search.project_title_or_project_code')
                  "
                ></search-input>
              </div>
            </div>
          </div>
          <ul class="list-group list-group-flush">
            <li
              class="list-group-item"
              v-for="home in lowList"
              :key="home.projectId"
              @click="selectProject(home)"
            >
              <div class="media">
                <div class="mr-2">
                  <img :src="home.projectIcon" class="project-icon" />
                </div>
                <div class="media-body">
                  <div class="h4">
                    {{ home.projectName }}
                  </div>
                  <div class="h5">
                    {{ home.projectLocation }}
                  </div>
                </div>
                <div class="mr-3 mt-2 h3">
                  {{ home.projectCode }}
                </div>
              </div>
              <hr />
              <div class="stat">
                <div class="col">
                  <h6 class="stat-ttl">Unit ทั้งหมด</h6>
                  <div class="count">{{ home.homes.length }}</div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">Unit ที่เปิดใช้งาน</h6>
                  <div class="count">
                    {{ home.homes.filter(unit => unit.isActive).length }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">จำนวนผู้ใช้</h6>
                  <div class="count">
                    {{ home.countUserVerified ? home.countUserVerified : 0 }}
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item py-3">
              <div class="media pt-2">
                <div class="media-body">
                  <div class="h4">ผลรวมทุกโครงการ<br /><br /></div>
                </div>
              </div>
              <div class="stat">
                <div class="col">
                  <h6 class="stat-ttl"><strong>รวม Unit ทั้งหมด</strong></h6>
                  <div class="count">{{ lowTotalStat.allUnit }}</div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>รวม Unit ที่เปิดใช้งาน</strong>
                  </h6>
                  <div class="count">{{ lowTotalStat.activeUnit }}</div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl"><strong>รวมจำนวนผู้ใช้</strong></h6>
                  <div class="count">{{ lowTotalStat.activeUser }}</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-6 d-flex" style="height: 100%">
        <div class="card col px-0 d-flex flex-column">
          <div class="card-header bg-success text-white">
            <div class="media">
              <div class="media-body h2 text-white">
                {{ $t("feature.contact.project.high_rise") }}
              </div>
              <div class="ml-3">
                <search-input
                  @search="highChange"
                  :placeholder="
                    $t('feature.member.search.project_title_or_project_code')
                  "
                ></search-input>
              </div>
            </div>
          </div>
          <ul class="list-group list-group-flush">
            <li
              class="list-group-item"
              v-for="home in highList"
              :key="home.projectId"
              @click="selectProject(home)"
            >
              <div class="media">
                <div class="mr-2">
                  <img :src="home.projectIcon" class="project-icon" />
                </div>
                <div class="media-body">
                  <div class="h4">
                    {{ home.projectName }}
                  </div>
                  <div class="h5">
                    {{ home.projectLocation }}
                  </div>
                </div>
                <div class="mr-3 mt-2 h3">
                  {{ home.projectCode }}
                </div>
              </div>
              <hr />
              <div class="stat">
                <div class="col">
                  <h6 class="stat-ttl">Unit ทั้งหมด</h6>
                  <div class="count">{{ home.homes.length }}</div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">Unit ที่เปิดใช้งาน</h6>
                  <div class="count">
                    {{ home.homes.filter(unit => unit.isActive).length }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">จำนวนผู้ใช้</h6>
                  <div class="count">
                    {{ home.countUserVerified ? home.countUserVerified : 0 }}
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item py-3">
              <div class="media pt-2">
                <div class="media-body">
                  <div class="h4">ผลรวมทุกโครงการ<br /><br /></div>
                </div>
              </div>
              <div class="stat">
                <div class="col">
                  <h6 class="stat-ttl"><strong>รวม Unit ทั้งหมด</strong></h6>
                  <div class="count">{{ highTotalStat.allUnit }}</div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>รวม Unit ที่เปิดใช้งาน</strong>
                  </h6>
                  <div class="count">{{ highTotalStat.activeUnit }}</div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl"><strong>รวมจำนวนผู้ใช้</strong></h6>
                  <div class="count">{{ highTotalStat.activeUser }}</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import JsonExcel from "vue-json-excel";
import { DatePicker } from "element-ui";
import moment from "moment";
import SearchInput from "@/components/helper/SearchInput";

export default {
  components: {
    SearchInput,
    downloadExcel: JsonExcel,
    elDatePicker: DatePicker
  },
  data() {
    return {
      home: [],
      lowList: [],
      highList: [],
      defaultReportDate: ["", ""],
      defaultCompareDate: ["", ""],
      compareDataWithDateRange: false,
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date();
        }
      },
      highTotalStat: {},
      lowTotalStat: {},
      statField: {},
      statData: [],
      userStatField: {},
      userStatData: [],
      statDataEmptyRow: {
        projectName: ""
      },
      normalStatField: {
        "Project Name": "projectName",
        "Project Code": "projectCode",
        "Project Type": "projectType",
        "Total Unit": "totalUnit",
        "Active Unit": "activeUnit",
        "Active User": "activeUser",
        Owner: "owner",
        Resident: "resident",
        Renter: "renter"
      },
      compareStatField: {
        "Project Name": "projectName",
        "Project Code": "projectCode",
        "Project Type": "projectType",
        "Total Unit": "totalUnit",
        "Active Unit": "activeUnit",
        "Active User": "activeUser",
        Owner: "owner",
        Resident: "resident",
        Renter: "renter",
        "": "emptyCol1",
        "Compare on date": "compareOnDate",
        "Compare Active Unit": "compareActiveUnit",
        "Compare Active User": "compareActiveUser",
        "Compare Owner": "compareOwner",
        "Compare Resident": "compareResident",
        "Compare Renter": "compareRenter"
      },
      normalRowStatField: {
        projectName: "Project Name",
        projectCode: "Project Code",
        projectType: "Project Type",
        totalUnit: "Total Unit",
        activeUnit: "Active Unit",
        activeUser: "Active User",
        owner: "Owner",
        resident: "Resident",
        renter: "Renter"
      },
      compareRowStatField: {
        projectName: "Project Name",
        projectCode: "Project Code",
        projectType: "Project Type",
        totalUnit: "Total Unit",
        activeUnit: "Active Unit",
        activeUser: "Active User",
        owner: "Owner",
        resident: "Resident",
        renter: "Renter",
        emptyCol1: "",
        compareOnDate: "Compare on date",
        compareActiveUnit: "Compare Active Unit",
        compareActiveUser: "Compare Active User",
        compareOwner: "Compare Owner",
        compareResident: "Compare Resident",
        compareRenter: "Compare Renter"
      },
      normalUserStatField: {
        "Project Name": "projectName",
        "Project Code": "projectCode",
        "Project Type": "projectType",
        "Home No.": "homeNo",
        "Customer Name": "customerName",
        Email: "email",
        "Mobile Number": "mobileNumber",
        "Verified Status": "verifiedStatus",
        "Verified Date": "verifiedDate"
      },
      normalRowUserStatField: {
        projectName: "Project Name",
        projectCode: "Project Code",
        projectType: "Project Type",
        homeNo: "Home No.",
        customerName: "Customer Name",
        email: "Email",
        mobileNumber: "Mobile Number",
        verifiedStatus: "Verified Status",
        verifiedDate: "Verified Date"
      }
    };
  },
  beforeMount() {
    this.initData();
  },
  methods: {
    dateFilter(ev) {
      this.initData();
    },
    dateCompare(ev) {
      this.initData("compare");
    },
    async initData(type = "") {
      // generate project member report
      this.statField =
        type == "compare" ? this.compareStatField : this.normalStatField;
      this.highTotalStat = {
        allUnit: 0,
        activeUnit: 0,
        activeUser: 0,
        owner: 0,
        resident: 0,
        renter: 0,
        compareActiveUnit: 0,
        compareActiveUser: 0,
        compareOwner: 0,
        compareResident: 0,
        compareRenter: 0
      };
      this.lowTotalStat = {
        allUnit: 0,
        activeUnit: 0,
        activeUser: 0,
        owner: 0,
        resident: 0,
        renter: 0,
        compareActiveUnit: 0,
        compareActiveUser: 0,
        compareOwner: 0,
        compareResident: 0,
        compareRenter: 0
      };
      this.statData = [];
      await this.getCondo();
      await this.getHome();

      const rowHeadTotalSummary = {
        projectName: "",
        projectCode: "",
        projectType: "",
        totalUnit: "Total Unit",
        activeUnit: "Active Unit",
        activeUser: "Active User",
        owner: "Owner",
        resident: "Resident",
        renter: "Renter"
      };
      const rowDataTotalSummary = {
        projectName: "Total Summary of High rise & Low rise",
        projectCode: "",
        projectType: "",
        totalUnit: this.lowTotalStat.allUnit + this.highTotalStat.allUnit,
        activeUnit:
          this.lowTotalStat.activeUnit + this.highTotalStat.activeUnit,
        activeUser:
          this.lowTotalStat.activeUser + this.highTotalStat.activeUser,
        owner: this.lowTotalStat.owner + this.highTotalStat.owner,
        resident: this.lowTotalStat.resident + this.highTotalStat.resident,
        renter: this.lowTotalStat.renter + this.highTotalStat.renter
      };

      if (
        this.defaultCompareDate[0] != "" ||
        this.defaultCompareDate[1] != ""
      ) {
        rowHeadTotalSummary.emptyCol1 = "";
        rowHeadTotalSummary.compareOnDate = "Compare on date";
        rowHeadTotalSummary.compareActiveUnit = "Compare Active Unit";
        rowHeadTotalSummary.compareActiveUser = "Compare Active User";
        rowHeadTotalSummary.compareOwner = "Compare Owner";
        rowHeadTotalSummary.compareResident = "Compare Resident";
        rowHeadTotalSummary.compareRenter = "Compare Renter";

        rowDataTotalSummary.emptyCol1 = "";
        rowDataTotalSummary.compareOnDate =
          moment(this.defaultCompareDate[0]).format("DD-MM-YYYY") +
          " - " +
          moment(this.defaultCompareDate[1]).format("DD-MM-YYYY");
        rowDataTotalSummary.compareActiveUnit =
          this.lowTotalStat.compareActiveUnit +
          this.highTotalStat.compareActiveUnit;
        rowDataTotalSummary.compareActiveUser =
          this.lowTotalStat.compareActiveUser +
          this.highTotalStat.compareActiveUser;
        rowDataTotalSummary.compareOwner =
          this.lowTotalStat.compareOwner + this.highTotalStat.compareOwner;
        rowDataTotalSummary.compareResident =
          this.lowTotalStat.compareResident +
          this.highTotalStat.compareResident;
        rowDataTotalSummary.compareRenter =
          this.lowTotalStat.compareRenter + this.highTotalStat.compareRenter;
      }

      this.statData.push(rowHeadTotalSummary);
      this.statData.push(rowDataTotalSummary);

      await this.getUserUnverified();

      // generate customer verified report
      await this.generateUserStatReport();
    },
    async getCondo(filter = "") {
      const vm = this;
      const dateFilter =
        this.defaultReportDate[0] == "" || this.defaultReportDate[1] == ""
          ? null
          : this.defaultReportDate;
      const dateCompare =
        this.defaultCompareDate[0] == "" || this.defaultCompareDate[1] == ""
          ? null
          : this.defaultCompareDate;

      await axios
        .get(`${process.env.HOST}/api/admin/projects/stat`, {
          headers: {
            projectId: localStorage.getItem("homeId"),
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`
          },
          params: {
            page: 1,
            status: "inprogress",
            type: "H",
            searchText: filter,
            dateFilter,
            dateCompare
          }
        })
        .then(async res => {
          vm.highList = res.data;
          vm.highList.sort((a, b) =>
            b.projectName > a.projectName
              ? -1
              : b.projectName < a.projectName
              ? 1
              : 0
          );

          await Promise.all(
            vm.highList.map(async item => {
              vm.highTotalStat.allUnit += item.homes.length;
              vm.highTotalStat.activeUnit += item.homes.filter(
                unit => unit.isActive
              ).length;
              vm.highTotalStat.activeUser += item.countUserVerified
                ? item.countUserVerified
                : 0;

              let owner = 0;
              let resident = 0;
              let renter = 0;
              await item.homes.map(home => {
                owner += home.roles.owner;
                resident += home.roles.resident;
                renter += home.roles.renter;
              });

              vm.highTotalStat.owner += owner;
              vm.highTotalStat.resident += resident;
              vm.highTotalStat.renter += renter;

              let rowObject = {
                projectName: item.projectName,
                projectCode: item.projectCode,
                projectType: "High Rise",
                totalUnit: item.homes.length,
                activeUnit: item.homes.filter(unit => unit.isActive).length,
                activeUser: item.countUserVerified ? item.countUserVerified : 0,
                owner: owner,
                resident: resident,
                renter: renter
              };

              if (dateCompare != null) {
                vm.highTotalStat.compareActiveUnit += item.compareHomes.filter(
                  unit => unit.isActive
                ).length;
                vm.highTotalStat.compareActiveUser += item.countCompareUserVerified
                  ? item.countCompareUserVerified
                  : 0;

                let compareOwner = 0;
                let compareResident = 0;
                let compareRenter = 0;
                await item.compareHomes.map(home => {
                  compareOwner += home.roles.owner;
                  compareResident += home.roles.resident;
                  compareRenter += home.roles.renter;
                });

                vm.highTotalStat.compareOwner += compareOwner;
                vm.highTotalStat.compareResident += compareResident;
                vm.highTotalStat.compareRenter += compareRenter;

                rowObject.emptyCol1 = "";
                rowObject.compareOnDate =
                  moment(this.defaultCompareDate[0]).format("DD-MM-YYYY") +
                  " - " +
                  moment(this.defaultCompareDate[1]).format("DD-MM-YYYY");
                rowObject.compareActiveUnit = item.compareHomes.filter(
                  unit => unit.isActive
                ).length;
                rowObject.compareActiveUser = item.countCompareUserVerified
                  ? item.countCompareUserVerified
                  : 0;
                rowObject.compareOwner = compareOwner;
                rowObject.compareResident = compareResident;
                rowObject.compareRenter = compareRenter;
              }

              vm.statData.push(rowObject);
            })
          );

          let rowTotalObject = {
            projectName: "Total Summary",
            projectCode: "",
            projectType: "",
            totalUnit: vm.highTotalStat.allUnit,
            activeUnit: vm.highTotalStat.activeUnit,
            activeUser: vm.highTotalStat.activeUser,
            owner: vm.highTotalStat.owner,
            resident: vm.highTotalStat.resident,
            renter: vm.highTotalStat.renter
          };

          if (dateCompare != null) {
            rowTotalObject.emptyCol1 = "";
            rowTotalObject.compareOnDate =
              moment(this.defaultCompareDate[0]).format("DD-MM-YYYY") +
              " - " +
              moment(this.defaultCompareDate[1]).format("DD-MM-YYYY");
            rowTotalObject.compareActiveUnit =
              vm.highTotalStat.compareActiveUnit;
            rowTotalObject.compareActiveUser =
              vm.highTotalStat.compareActiveUser;
            rowTotalObject.compareOwner = vm.highTotalStat.compareOwner;
            rowTotalObject.compareResident = vm.highTotalStat.compareResident;
            rowTotalObject.compareRenter = vm.highTotalStat.compareRenter;
          }

          vm.statData.push(rowTotalObject);
          this.statData.push(this.statDataEmptyRow);
        })
        .catch(e => {
          throw e;
        });
    },
    async getHome(filter = "") {
      const vm = this;
      const dateFilter =
        this.defaultReportDate[0] == "" || this.defaultReportDate[1] == ""
          ? null
          : this.defaultReportDate;
      const dateCompare =
        this.defaultCompareDate[0] == "" || this.defaultCompareDate[1] == ""
          ? null
          : this.defaultCompareDate;

      await axios
        .get(`${process.env.HOST}/api/admin/projects/stat`, {
          headers: {
            projectId: localStorage.getItem("homeId"),
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`
          },
          params: {
            page: 1,
            status: "inprogress",
            type: "L",
            searchText: filter,
            dateFilter,
            dateCompare
          }
        })
        .then(async res => {
          vm.lowList = res.data;
          vm.lowList.sort((a, b) =>
            b.projectName > a.projectName
              ? -1
              : b.projectName < a.projectName
              ? 1
              : 0
          );

          const rowHeadStatField =
            dateCompare != null
              ? this.compareRowStatField
              : this.normalRowStatField;
          vm.statData.push(rowHeadStatField);
          await Promise.all(
            vm.lowList.map(async item => {
              vm.lowTotalStat.allUnit += item.homes.length;
              vm.lowTotalStat.activeUnit += item.homes.filter(
                unit => unit.isActive
              ).length;
              vm.lowTotalStat.activeUser += item.countUserVerified
                ? item.countUserVerified
                : 0;

              let owner = 0;
              let resident = 0;
              let renter = 0;
              await item.homes.map(home => {
                owner += home.roles.owner;
                resident += home.roles.resident;
                renter += home.roles.renter;
              });

              vm.lowTotalStat.owner += owner;
              vm.lowTotalStat.resident += resident;
              vm.lowTotalStat.renter += renter;

              let rowObject = {
                projectName: item.projectName,
                projectCode: item.projectCode,
                projectType: "Low Rise",
                totalUnit: item.homes.length,
                activeUnit: item.homes.filter(unit => unit.isActive).length,
                activeUser: item.countUserVerified ? item.countUserVerified : 0,
                owner: owner,
                resident: resident,
                renter: renter
              };

              if (dateCompare != null) {
                vm.lowTotalStat.compareActiveUnit += item.compareHomes.filter(
                  unit => unit.isActive
                ).length;
                vm.lowTotalStat.compareActiveUser += item.countCompareUserVerified
                  ? item.countCompareUserVerified
                  : 0;

                let compareOwner = 0;
                let compareResident = 0;
                let compareRenter = 0;
                await item.compareHomes.map(home => {
                  compareOwner += home.roles.owner;
                  compareResident += home.roles.resident;
                  compareRenter += home.roles.renter;
                });

                vm.lowTotalStat.compareOwner += compareOwner;
                vm.lowTotalStat.compareResident += compareResident;
                vm.lowTotalStat.compareRenter += compareRenter;

                rowObject.emptyCol1 = "";
                rowObject.compareOnDate =
                  moment(this.defaultCompareDate[0]).format("DD-MM-YYYY") +
                  " - " +
                  moment(this.defaultCompareDate[1]).format("DD-MM-YYYY");
                rowObject.compareActiveUnit = item.compareHomes.filter(
                  unit => unit.isActive
                ).length;
                rowObject.compareActiveUser = item.countCompareUserVerified
                  ? item.countCompareUserVerified
                  : 0;
                rowObject.compareOwner = compareOwner;
                rowObject.compareResident = compareResident;
                rowObject.compareRenter = compareRenter;
              }

              vm.statData.push(rowObject);
            })
          );

          let rowTotalObject = {
            projectName: "Total Summary",
            projectCode: "",
            projectType: "",
            totalUnit: vm.lowTotalStat.allUnit,
            activeUnit: vm.lowTotalStat.activeUnit,
            activeUser: vm.lowTotalStat.activeUser,
            owner: vm.lowTotalStat.owner,
            resident: vm.lowTotalStat.resident,
            renter: vm.lowTotalStat.renter
          };

          if (dateCompare != null) {
            rowTotalObject.emptyCol1 = "";
            rowTotalObject.compareOnDate =
              moment(this.defaultCompareDate[0]).format("DD-MM-YYYY") +
              " - " +
              moment(this.defaultCompareDate[1]).format("DD-MM-YYYY");
            rowTotalObject.compareActiveUnit =
              vm.lowTotalStat.compareActiveUnit;
            rowTotalObject.compareActiveUser =
              vm.lowTotalStat.compareActiveUser;
            rowTotalObject.compareOwner = vm.lowTotalStat.compareOwner;
            rowTotalObject.compareResident = vm.lowTotalStat.compareResident;
            rowTotalObject.compareRenter = vm.lowTotalStat.compareRenter;
          }

          vm.statData.push(rowTotalObject);
          this.statData.push(this.statDataEmptyRow);
        })
        .catch(e => {
          throw e;
        });
    },
    async getUserUnverified() {
      const vm = this;
      const dateFilter =
        this.defaultReportDate[0] == "" || this.defaultReportDate[1] == ""
          ? null
          : this.defaultReportDate;
      const dateCompare =
        this.defaultCompareDate[0] == "" || this.defaultCompareDate[1] == ""
          ? null
          : this.defaultCompareDate;

      await axios
        .get(
          `${process.env.HOST}/admin/member-management/count-unverified-user`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`
            },
            params: { dateFilter, dateCompare }
          }
        )
        .then(res => {
          const rowHeadTotalSummary = {
            projectName: "",
            projectCode: "Unverified User Total",
            projectType: "",
            totalUnit: dateCompare != null ? "Compare Date" : "",
            activeUnit:
              dateCompare != null ? "Unverified User Total Compare By Date" : ""
          };

          const rowDataTotalSummary = {
            projectName: "Total Count",
            projectCode: res.data.userUnVerifiedCount,
            projectType: "",
            totalUnit:
              dateCompare != null
                ? moment(this.defaultCompareDate[0]).format("DD-MM-YYYY") +
                  " - " +
                  moment(this.defaultCompareDate[1]).format("DD-MM-YYYY")
                : "",
            activeUnit:
              dateCompare != null ? res.data.userUnVerifiedCompareCount : ""
          };

          this.statData.push(this.statDataEmptyRow);
          this.statData.push(rowHeadTotalSummary);
          this.statData.push(rowDataTotalSummary);
        })
        .catch(e => {
          throw e;
        });
    },
    lowChange(searchText) {
      this.getHome(searchText);
    },
    highChange(searchText) {
      this.getCondo(searchText);
    },
    selectProject(home) {
      localStorage.setItem("projectId", home.projectId);
      localStorage.setItem("projectName", home.projectName);
      localStorage.setItem("projectIcon", home.projectIcon);
      this.$router.push({ name: "Member", params: { homeId: "all" } });
    },
    async generateUserStatReport() {
      const vm = this;
      vm.userStatField = vm.normalUserStatField;

      const emptyRow = {
        projectName: "",
        projectCode: "",
        projectType: "",
        homeNo: "",
        customerName: "",
        email: "",
        mobileNumber: "",
        verifiedStatus: "",
        verifiedDate: ""
      };

      await vm.lowList.forEach(async (project, index) => {
        const { projectName, projectCode, projectType, homes } = project;

        await homes.forEach(async home => {
          if (home.users.length > 0) {
            await home.users.forEach(async user => {
              const objRow = {
                projectName,
                projectCode,
                projectType,
                homeNo: `="${home.addressNo}"`,
                customerName: user.firstName + " " + user.lastName,
                email: user.email != null ? user.email : "-",
                mobileNumber:
                  user.mobileNumber != null ? `="${user.mobileNumber}"` : "-",
                verifiedStatus:
                  user.activedAt != null ? "already verified" : "not verified",
                verifiedDate: user.activedAt != null ? user.activedAt : "-"
              };

              vm.userStatData.push(objRow);
            });
          }
        });
      });

      vm.userStatData.push(emptyRow);
      vm.userStatData.push(vm.normalRowUserStatField);

      await vm.highList.forEach(async (project, index) => {
        const { projectName, projectCode, projectType, homes } = project;
        await homes.forEach(async home => {
          if (home.users.length > 0) {
            await home.users.forEach(async user => {
              const objRow = {
                projectName,
                projectCode,
                projectType,
                homeNo: `="${home.addressNo}"`,
                customerName: user.firstName + " " + user.lastName,
                email: user.email != null ? user.email : "-",
                mobileNumber:
                  user.mobileNumber != null ? `="${user.mobileNumber}"` : "-",
                verifiedStatus:
                  user.activedAt != null ? "already verified" : "not verified",
                verifiedDate: user.activedAt != null ? user.activedAt : "-"
              };

              vm.userStatData.push(objRow);
            });
          }
        });
      });
    }
  }
};
</script>
<style lang="css" scoped>
#member-project {
  border-top: 1px solid #e0e0e0;
  height: calc(100% - 110px);
}

.content-list {
  height: calc(100% - 220px);
}

.card {
  margin-top: 10px;
  margin-bottom: 20px;
  box-shadow: 0 4px 16px 0 rgba(215, 215, 215, 0.7);
}
.card .list-group {
  overflow-y: auto;
}
#member-project .list-group-item{
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.project-icon {
    width: 40px;
    height: 40px;
    background-color: #eee;
    border-radius: 15px;
    border: #ccc 1px solid;
}

.stat:after {
  display: block;
  content: '';
  clear: both;
}
.stat .col {
  float: left;
  width: 33.33%;
  text-align: center;
  padding: 5px 0 0 0;
  border-right: solid 1px #ccc;
}
.stat .col:last-child {
  border: none;
}
.stat .stat-ttl {
  font-size: 13px;
  margin-bottom: 0;
}
.stat .count {
  font-size: 14px;
  padding: 5px 0;
}
.sc-btn {
  display: inline-block;
  width: auto;
  padding: 6px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/member/MemberProjects.vue